import { render, staticRenderFns } from "./replacementProductionYearPieChart.vue?vue&type=template&id=1ec07916&scoped=true"
import script from "./replacementProductionYearPieChart.vue?vue&type=script&lang=js"
export * from "./replacementProductionYearPieChart.vue?vue&type=script&lang=js"
import style0 from "./replacementProductionYearPieChart.vue?vue&type=style&index=0&id=1ec07916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec07916",
  null
  
)

export default component.exports